import * as React from "react";
import footer from "../../assets/images/IA_Nani_footer.png";
import {Grid, Typography, Divider, Button, Box} from "@mui/material";
import { Link } from "react-router-dom";

const styles = {
	paperContainer: {
		backgroundImage: `url(${footer})`,
		backgroundSize: "cover"
	},
	FooterButton: {
		fontFamily: "ProximaNova-Bold",
		color: "#000000"
	}
};

export default function Footer() {
	return (
		<Box
			style={styles.paperContainer}
			sx={{ zIndex: "0"}}
			display='flex'
		>
			<Grid container
				spacing={2}
			>
				<Grid item xs={5}>
					<Typography variant={"subtitle1"} sx={{ pl:6 }}>Acknowledgement of Country</Typography>
					<Typography variant={"subtitle2"} sx={{ pl:6 }}> Infrastructure Australia acknowledges the Traditional Owners of Country throughout Australia and recognises the continuing connection to lands, waters and communities. We pay our respect to Aboriginal and Torres Strait Islander cultures; and to Elders past and present.</Typography>
				</Grid>
				<Grid item xs={12}>
					<Box bgcolor="#DEE0DF">
						<Grid
							container
							spacing={1}
							justifyContent='center'

						>
							<Grid item>
								<Button style={styles.FooterButton} component={Link} to={"https://www.infrastructureaustralia.gov.au/copyright-statement"}>COPYRIGHT</Button>
							</Grid>
							<Divider
								orientation={"vertical"}
								variant={"middle"}
								flexItem
								sx={{pl: 1}}/>
							<Grid item>
								<Button style={styles.FooterButton} component={Link} to={"https://www.infrastructureaustralia.gov.au/disclaimer"}>DISCLAIMER</Button>
							</Grid>
							<Divider
								orientation={"vertical"}
								variant={"middle"}
								flexItem
								sx={{pl: 1}}/>
							<Grid item>
								<Button style={styles.FooterButton} component={Link} to={"https://www.infrastructureaustralia.gov.au/freedom-information"}>FOI</Button>
							</Grid>
							<Divider
								orientation={"vertical"}
								variant={"middle"}
								flexItem
								sx={{pl: 1}}/>
							<Grid item>
								<Button style={styles.FooterButton} component={Link} to={"https://www.infrastructureaustralia.gov.au/privacy-statement"}>PRIVACY</Button>
							</Grid>
							<Divider
								orientation={"vertical"}
								variant={"middle"}
								flexItem
								sx={{pl: 1}}/>
							<Grid item>
								<Button style={styles.FooterButton} component={Link} to={"mailto:scenario.modelling@infrastructureaustralia.gov.au"}>CONTACTS</Button>
							</Grid>
						</Grid>
					</Box>
				</Grid>
			</Grid>
		</Box>
	);
}
